module.exports = __webpack_public_path__ + "static/media/26UNRWA9.9e484987.jpg";